import classNames from 'classnames';
import React from 'react';

import IlloCream from '../../assets/svg/illo-cream.inline.svg';
import { AlmaLink } from '../alma-link';
import * as styles from './learnMore.module.css';

export function LearnMore({
	colorTheme,
	ctas,
	eyebrowText,
	headerText,
	illustration,
	subheaderText,
	verticalPadding,
}) {
	const isTransparent = colorTheme === 'transparent';

	// module spacing
	const modulePaddingTop = verticalPadding?.modulePaddingTop;
	const modulePaddingBottom = verticalPadding?.modulePaddingBottom;

	return (
		<div
			className={classNames(
				styles.moduleContainer,
				styles[colorTheme],
				modulePaddingTop,
				modulePaddingBottom
			)}
		>
			<div className={styles.contentGridWrapper}>
				<div
					className={classNames(
						'footer-image',
						styles.imageContainer
					)}
				>
					{isTransparent ? (
						<IlloCream />
					) : (
						<span
							dangerouslySetInnerHTML={{
								__html: illustration?.svg,
							}}
						></span>
					)}
				</div>

				<div className={styles.copyContainer}>
					{eyebrowText && (
						<h2 className='heading-xs'>{eyebrowText}</h2>
					)}
					{headerText && eyebrowText && (
						<h3 className='heading-l'>{headerText}</h3>
					)}
					{headerText && !eyebrowText && (
						<h2 className='heading-l'>{headerText}</h2>
					)}
					<p className={classNames('body', styles.subheaderText)}>
						{subheaderText ||
							'Get the tools and resources you need to build a thriving private practice, powered by Alma.'}
					</p>
					{ctas && (
						<div className={styles.ctaContainer}>
							{ctas.map((footerLink, idx) => {
								return <AlmaLink cta={footerLink} key={idx} />;
							})}
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
